import { Caret } from './Caret';
export default Caret;



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/Caret/index.js